export type MountedStripeElement = {
  destroy?: () => void;
};

export function destroyStripeElementSafely(element: MountedStripeElement | null | undefined) {
  if (!element) {
    return;
  }

  try {
    element.destroy?.();
  } catch (error) {
    if (error instanceof Error && /already been destroyed/i.test(error.message)) {
      return;
    }

    throw error;
  }
}
